import React, { useState } from "react";
import "./MainLayout.css";
import LeftSideBar from "../../components/LeftSideBar";
import TopNavBar from "../../components/TopNavBar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";
import { CompanyProvider } from "../../context/CompanyContext";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { readStoredJson } from "../../utilities/session";

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const user =
    location.state?.user || readStoredJson("user", {});

  const handleLogout = () => {
    dispatch(logout()); // clears the stored session too
    navigate("/", { replace: true });
    window.location.reload();
  };

  return (
    <CompanyProvider>
      <div className="dashboard-container">
        <LeftSideBar isOpen={isSidebarOpen} user={user} />

        <main className="main-content">
          <TopNavBar
            toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
            onLogout={handleLogout}
            user={user}
          />

          <div className="page-content">
            <Outlet />
          </div>
          <Footer />
        </main>

        {isSidebarOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.5)",
              zIndex: 900,
            }}
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </div>
    </CompanyProvider>
  );
};

export default MainLayout;
